import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import tplHelpers from "../../../helpers/tpl";
import ThirdPartyLogisticsOrdersForm from './ThirdPartyLogisticsInventoryForm';
import ThirdPartyLogisticsInventoryTable from './ThirdPartyLogisticsInventoryTable';

function ThirdPartyLogisticsOrders(props) {

    const [inventory, setInventory] = useState([]);
    const [warehouse, setWarehouse] = useState("");
    const [warehouseName, setWarehouseName] = useState("");

    const warehouse_options = [
        {value: 10, name: 'Geodis'},
        {value: 11, name: 'Standvast'},
    ];

    useEffect(() => {
        setInventory([]);
        const selectedWarehouse = warehouse_options.find(option => option.value === warehouse);
        setWarehouseName(selectedWarehouse ? selectedWarehouse.name.toLowerCase() : ""); 
    }, [warehouse]);

    const get3PLInventory = async () => {
        props.setLoading(true);
        try {
            if (warehouse === 10) {
                const geodis_inventory = await tplHelpers.getGeodisInventory(props.company, props.token);
                setInventory(geodis_inventory);
            } else {
                props.toast.error(`We currently do not receive an inventory feed from ${warehouseName}!`);
            };
        } catch (err) {
            console.log(err);
            props.toast.error('Failed to get inventory')
        } finally {
            props.setLoading(false);
        };
    };

    const exportInventory = async() => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["sku", "acumatica_available", `${warehouseName}_available`].join(",")
        ];
        for(let sku of inventory) {
            console.log(sku.sku)
            data.push(
                [sku.sku, sku.acumatica?.available, sku[warehouseName]?.available].join(",")
            );
        };
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} ${warehouseName.charAt(0).toUpperCase() + warehouseName.slice(1)}InventoryExport.csv`);
        document.body.appendChild(a);
        a.click();
    }

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>3PL Inventory</h1> 
                <ThirdPartyLogisticsOrdersForm
                    get3PLInventory = {get3PLInventory}
                    inventory = {inventory}
                    warehouse = {warehouse}
                    setWarehouse = {setWarehouse}
                    warehouse_options = {warehouse_options}
                 />
                { warehouse ?
                    <ThirdPartyLogisticsInventoryTable 
                        isMobile = {props.isMobile}
                        warehouseName = {warehouseName}
                        inventory = {inventory}
                        exportInventory = {exportInventory}
                    />
                : null }
            </Box>
        </Box>
    )
}

export default ThirdPartyLogisticsOrders;